import { api } from "../network/api";
import { ENDPOINTS } from "@/constants/endpoints";
import type { BaseResponse } from "@/models/responses/base/baseResponse.response";
import type {
  VerifyComplianceDetails,
  VerifyComplianceSearchResult,
} from "@/models/responses/verify-compliance/verify-compliance.response";

const VerifyComplianceService = {
  // Public search by company name or RC (CAC) number.
  search: async function (q: string): Promise<VerifyComplianceSearchResult[]> {
    const response = (await api.get(
      ENDPOINTS.VERIFY_COMPLIANCE.SEARCH(q)
    )) as unknown as BaseResponse<VerifyComplianceSearchResult[]>;
    return response.data ?? [];
  },

  // Public compliance verification details for a single company.
  getDetails: async function (
    employerCode: string
  ): Promise<VerifyComplianceDetails> {
    const response = (await api.get(
      ENDPOINTS.VERIFY_COMPLIANCE.DETAILS(employerCode)
    )) as unknown as BaseResponse<VerifyComplianceDetails>;
    return response.data;
  },
};

export default VerifyComplianceService;
